import React, { useEffect, useState } from 'react';
import { Box, Chip, Typography, Stack } from '@mui/material';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../utils/api';

const API_BASE = API_BASE_URL;

interface BlogPost { id: number; title: string; slug: string; content: string; coverImageUrl?: string; tags?: string[]; publishedAt?: string; featured?: boolean; authorName?: string; }

const BlogPostPage: React.FC = () => {
  const { slug } = useParams();
  const [post, setPost] = useState<BlogPost | null>(null);

  useEffect(() => {
    (async () => {
      const res = await fetch(`${API_BASE}/blog/${slug}`);
      if (res.ok) setPost(await res.json());
    })();
  }, [slug]);

  if (!post) return null;

  return (
    <Box>
      <Typography variant="h3" gutterBottom>{post.title}</Typography>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        {post.featured && <Chip size="small" color="warning" label="Featured" />}
        {post.publishedAt && (
          <Typography variant="caption" color="text.secondary">
            {new Date(post.publishedAt).toLocaleString()}
          </Typography>
        )}
      </Stack>
      {post.authorName && (
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2 }}>
          By {post.authorName}
        </Typography>
      )}
      <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        {(Array.isArray(post.tags) ? post.tags : []).map((t) => (
          <Chip key={t} size="small" label={t} />
        ))}
      </Box>
      {post.coverImageUrl && (
        <img src={post.coverImageUrl} alt={post.title} style={{ maxWidth: '100%', borderRadius: 8, marginBottom: 16 }} />
      )}
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </Box>
  );
};

export default BlogPostPage;